import { render, staticRenderFns } from "./ResTxt.vue?vue&type=template&id=63ef9f24&scoped=true"
import script from "./ResTxt.vue?vue&type=script&lang=ts"
export * from "./ResTxt.vue?vue&type=script&lang=ts"
import style0 from "./ResTxt.vue?vue&type=style&index=0&id=63ef9f24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ef9f24",
  null
  
)

export default component.exports